export const cnameSubdomainValidator = (value) => {
    if (!value) return "validate.cname_subdomain_required";

    if (value === "@") return "validate.cname_subdomain_not_root";

    const regex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return regex.test(value) ? true : "validate.cname_subdomain_format";
}; 